/*
 * @Description: 
 * @Version: 2.0
 * @Autor: YGQ
 * @Date: 2024-02-26 14:54:58
 * @LastEditors: YGQ
 * @LastEditTime: 2024-11-21 10:51:29
 */
export const URL = {
  release: "https://pms.geemro.com/pms-manage-php/public/index.php/", // 发布版接口地址
  trial: "https://trial.geemro.com/pms-manage-php/public/index.php/", // oneid 开发环境接口地址
  develop: "https://dev.geemro.com/pms-manage-php/public/index.php/", // 开发版接口地址
  local: "/api-proxy/", // 本地版接口地址
  localTrial: "/trial-api-proxy/", // 本地版接口地址
};

// 用户中心地址
export const SSO_HOST = {
  release: 'https://oneid.geemro.com', // 发布版用户认证主机地址
  trial: 'https://trial.geemro.com', // 体验版用户认证主机地址
  develop: 'https://dev.geemro.com', // 开发版用户认证主机地址
  local: 'https://dev.geemro.com', // 开发版用户认证主机地址
  localTrial: 'https://trial.geemro.com', // 开发版用户认证主机地址
}


export const ROUTE_MAP = [
  {
    label: '酒店品牌',
    path: '/',
  },
  {
    label: '关于舒悦',
    path: '/about',
  },
  {
    label: '加盟舒悦',
    path: '/join',
  },
]